import { render } from "./SubFranchiseAdmin.vue?vue&type=template&id=7d72f354"
import script from "./SubFranchiseAdmin.vue?vue&type=script&lang=js"
export * from "./SubFranchiseAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__